import React from "react";

export function PasskeyIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden
    >
      <g stroke="currentColor" strokeWidth={2}>
        <path d="M35.333 16.961c0 3.045-1.874 5.634-4.483 6.58l1.578 2.613-2.336 2.872 2.336 2.808-3.765 5.052-2.653-2.832V23.348C23.65 22.277 22 19.82 22 16.961 22 13.117 24.985 10 28.667 10c3.681 0 6.666 3.117 6.666 6.961Zm-6.668 1.065c.888 0 1.609-.751 1.609-1.679s-.72-1.681-1.609-1.681c-.888 0-1.608.751-1.608 1.681-.002.928.72 1.68 1.608 1.68ZM19.023 17.69c.398 2.8 1.75 5.278 3.701 7.03v1.977c0 .69-.547 1.225-1.192 1.225H6.192c-.645 0-1.192-.534-1.192-1.225v-5.56c0-1.919 1.528-3.448 3.383-3.448h10.64ZM12.142 14.026l-.003-.002c-1.574-.66-2.48-1.84-2.786-3.615-.219-1.264-.111-2.477.38-3.613.676-1.56 1.85-2.395 3.49-2.691 1.016-.183 1.983-.135 2.899.206 1.378.513 2.279 1.47 2.71 2.934.463 1.567.389 3.09-.29 4.531l-.001.003c-.665 1.424-1.803 2.197-3.363 2.514h-.002l-.218.045h-.002l-.126.025c-.472-.005-.945-.006-1.413-.006-.516-.098-.908-.176-1.275-.331Z" />
      </g>
    </svg>
  );
}
